
<div class="flex flex-col pt-4">
    <hr *ngIf="showGenerateReportButton ||
        showFinaliseButton ||
        showApproveAndRejectButtons ||
        showNotApplicableButton ||
        showSnzReviewButton"
     class="w-full border-2 border-black">

    <div class="flex flex-row flex-wrap justify-between gap-4 pt-4">
        <app-srs-report
            *ngIf="showGenerateReportButton"
            [srsBallotDetail]="srsBallotDetail"
            [isSrsBallot]="true"></app-srs-report>

        <div class="flex flex-row flex-wrap gap-4 lg:justify-end">
            <button
                *ngIf="showFinaliseButton"
                class="btn btn-primary-blue"
                [disabled]="!isFinalisedButtonEnabled"
                id="btn-srs-ballot-review-outcome-finalise"
                (click)="openFinaliseBallotModal()"
            >Finalise</button>

            <button
                *ngIf="showApproveAndRejectButtons"
                class="btn btn-primary-blue"
                id="btn-srs-ballot-review-outcome-approve"
                (click)="onButtonClicked(reviewAction.Approve)"
            >Approve</button>

            <button
                *ngIf="showApproveAndRejectButtons"
                class="btn btn-primary-blue"
                id="btn-srs-ballot-review-outcome-reject"
                (click)="onButtonClicked(reviewAction.Reject)"
            >Reject</button>

            <button
                *ngIf="showNotApplicableButton"
                class="btn btn-primary-blue"
                id="btn-srs-ballot-review-outcome-not-applicable"
                (click)="onButtonClicked(reviewAction.NotApplicable)"
            >Not Applicable</button>

            <button
                *ngIf="showSnzReviewButton"
                class="btn btn-primary-blue"
                id="btn-srs-ballot-review-outcome-completed"
                (click)="onButtonClicked(reviewAction.CompletedApprovalNotRequired)"
            >SNZ Review Complete</button>
        </div>
    </div>
</div>
